import { render } from "./UserProgress.vue?vue&type=template&id=10f288fb&scoped=true"
import script from "./UserProgress.vue?vue&type=script&lang=js"
export * from "./UserProgress.vue?vue&type=script&lang=js"

import "./UserProgress.vue?vue&type=style&index=0&id=10f288fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f288fb"]])

export default __exports__